import HttpLoadingBar from "owp.http-loading-bar";
import type { JSX } from "preact";
import "./LoadingBar.css";

/*
Force PurgecssPlugin to keep
progress
progress-bar
*/

export function LoadingBar(): JSX.Element {
    return (
        <HttpLoadingBar
            className="sticky-top rounded-0"
            classNameInner="progress-bar-striped"
        />
    );
}
